import React, { useState, useMemo, useCallback } from 'react';
import { Popover } from 'react-tiny-popover';
import PropTypes from 'prop-types';

import ContainerStyle from './Styles';

const propTypes = {
  align: PropTypes.string.isRequired,
  position: PropTypes.arrayOf(PropTypes.string).isRequired,
  renderContent: PropTypes.func.isRequired,
  renderChild: PropTypes.func.isRequired,
  contentLocation: PropTypes.func,
  handleClickOutside: PropTypes.func,
  popOverChildRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  validateClickOutside: PropTypes.bool
};

const defaultProps = {
  contentLocation: popoverState => {
    const { childRect, parentRect } = popoverState;
    return { top: childRect.top - parentRect.top, left: childRect.left };
  },
  handleClickOutside: () => {},
  popOverChildRef: undefined,
  validateClickOutside: false
};

const PopoverWrapper = ({
  renderChild,
  renderContent,
  align,
  position,
  contentLocation,
  handleClickOutside,
  popOverChildRef,
  validateClickOutside
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const renderContentFn = useMemo(() => {
    return renderContent.bind(null, setIsPopoverOpen);
  }, [renderContent]);

  const renderChildFn = useMemo(() => {
    return renderChild.bind(null, setIsPopoverOpen);
  }, [renderChild]);

  const onClickOutside = useCallback(
    e => {
      if (
        validateClickOutside &&
        (e?.target?.children['notification-icon'] ||
          e?.target?.children[0]?.children?.['notification-icon'])
      ) {
        return;
      }
      handleClickOutside();
      setIsPopoverOpen(false);
    },
    [handleClickOutside, validateClickOutside]
  );

  return (
    <Popover
      isOpen={isPopoverOpen}
      align={align}
      positions={position}
      contentLocation={contentLocation}
      containerStyle={ContainerStyle}
      onClickOutside={onClickOutside}
      content={renderContentFn}
      ref={popOverChildRef}
    >
      {renderChildFn()}
    </Popover>
  );
};

PopoverWrapper.propTypes = propTypes;
PopoverWrapper.defaultProps = defaultProps;

export default PopoverWrapper;
